<template>
  <div>
    <button class="edit" @click.prevent="refresh()">
      Re-calculate crew hours
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EventBus from "@/eventbus.js";

export default {
  methods: {
    ...mapActions(["recalculateCrewHours"]),
    showNotification(message) {
      EventBus.$emit("message", {
        text: message,
      });
    },
    refresh() {
      this.recalculateCrewHours()
        .then(() => {
          this.showNotification("Crew hours recalculated successfully");
        })
        .catch((error) => {
          this.showNotification("Failed to recalculate crew hour");
        });
    },
  },
};
</script>
